export const contactIllustrationImg =
  "https://res.cloudinary.com/laborhack/image/upload/v1616416408/page%20assets/3969587_zmopxp.jpg";

export const LaborHackSocialLinks = {
  facebook: "https://facebook.com/laborhackng",
  twitter: "https://twitter.com/laborhack_ng",
  instagram: "https://www.instagram.com/laborhack/",
  linkedin: "https://linkedin.com/company/laborhack-limited",
};
